module.exports = __webpack_public_path__ + "static/media/plus.5f64910d.svg";